import { useState } from "react";
import { Button, Table } from "flowbite-react";
import { FaRegTrashAlt } from "react-icons/fa";
import DateFormatter from "../dates/DateFormatter";
import DeleteModal from "./DeleteModal";
import { HiPencil } from "react-icons/hi";

const BrandRow = ({ brand, fetchBrands, onEdit }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <Table.Row key={brand._id} className="bg-white">
      <Table.Cell>
        <div
          onClick={() => onEdit(brand)}
          className="text-gray-900 hover:underline font-medium cursor-pointer"
        >
          {brand.name}
        </div>
      </Table.Cell>
      <Table.Cell>
        <DateFormatter date={brand.createdAt} />
      </Table.Cell>
      <Table.Cell className="flex gap-2 items-center">
        <Button onClick={() => onEdit(brand)}>
          <HiPencil />
        </Button>
        <Button
          onClick={() => setOpenModal(true)}
          color="failure"
        >
          <FaRegTrashAlt />
        </Button>
        <DeleteModal
          brand={brand}
          fetchBrands={fetchBrands}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default BrandRow;
